import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Typography, Button, TextField, Table, TableBody, TableCell,
    TableHead, TableRow, TableContainer, Paper, Pagination, Stack
} from '@mui/material';

const Organizations = () => {

    const navigate = useNavigate();
    const [users, setUsers] = useState([
    ]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [name, setName] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const handleEdit = (user) => {
        // Navigate to the user edit page
        navigate(`/Organizations/${user.id}/update`);
    };

    const handleSubmit = () => {
        if (selectedUser) {
            setUsers(users.map(u => u.id === selectedUser.id ? { ...u, name } : u));
        } else {
            const newUser = { id: Date.now(), name };
            setUsers([...users, newUser]);
        }
        setName('');
        setSelectedUser(null);
    };

    const paginated = users.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <>
            <Typography variant="h5">Organizations</Typography>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ my: 2 }}>
                <TextField label="Name" value={name} onChange={e => setName(e.target.value)} />
                <Button variant="contained" onClick={handleSubmit}>
                    {selectedUser ? 'Update' : 'Add New'}
                </Button>
            </Stack>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow><TableCell>ID</TableCell><TableCell>Name</TableCell><TableCell>Actions</TableCell></TableRow>
                    </TableHead>
                    <TableBody>
                        {paginated.map(user => (
                            <TableRow key={user.id}>
                                <TableCell>{user.id}</TableCell>
                                <TableCell>{user.name}</TableCell>
                                <TableCell>
                                    <Button variant="outlined" onClick={() => {}}>Operations</Button>
                                    <Button variant="outlined" onClick={() => handleEdit(user)}>Modify</Button>
                                    <Button variant="outlined" onClick={() => {}}>Disable</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                count={Math.ceil(users.length / itemsPerPage)}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                sx={{ mt: 2 }}
            />
        </>
    );
};

export default Organizations;
